import $ from 'jquery';
import { toCamelCase} from './strings';

import { collectElementOptions} from './objects';

/**
 * Generate a jQuery plugin
 * @param pluginName [string] Plugin name
 * @param className [object] Class of the plugin
 * @param shortHand [bool] Generate a shorthand as $.pluginName
 *
 * @example
 * import plugin from 'plugin';
 *
 * class MyPlugin {
 *     constructor(element, options) {
 *         // ...
 *     }
 * }
 *
 * or
 *
 * function MyPlugin (element, options) {
 *   assert(options.something, true);
 * }
 *
 * then
 *
 * MyPlugin.DEFAULTS = {
 *   something: false
 * };
 *
 * plugin('myPlugin', MyPlugin);
 *
 * $(() => {
 *   $('[data-my-plugin]').myPlugin();
 * })
 *
 * <div data-my-plugin data-my-plugin-something="true"></div>
 */
export default function plugin(pluginName, className, shortHand = false) {
    const dataName = `__${pluginName}`;
    const old = $.fn[pluginName];
    const ZERO = 0;

    className.$bus = {
        subscribe: function(event, fn) {
            $(this).bind(event, fn);
        },
        publish: function(event, data) {
            $(this).trigger(event, [data]);
        }
    };

    $.fn[pluginName] = function PluginFactory (option, args) {
        return this.each(function PluginInstanceFactory () {
            const $this = $(this);
            const overrides = typeof option === 'object' && option;
            const elementOptions = collectElementOptions(pluginName, $this.data());

            let instance = $this.data(dataName);
            const options = $.extend({}, className.DEFAULTS, elementOptions, overrides);

            // store reference to instance
            if (!instance) {
                $this.data(dataName, instance = new className(this, options));
            }

            // execute instance method
            if (typeof option === 'string') {
                if (typeof instance[option] != 'function') {
                    console.warn(`${pluginName}.${option} is not a function`);
                } else {
                    return instance[option](args);
                }
            }
        });
    };

    // - Short hand
    if (shortHand) {
        $[pluginName] = (options) => $({})[pluginName](options);
    }

    // - No conflict
    $.fn[pluginName].noConflict = function noConflict () {
        $.fn[pluginName] = old;
    };
}

$.fn.behaviour = function (name) {
    return $(this).data(`__${name}`);
};
export function jquery (name) {
    return function decroate (target) {
        plugin(name, target);
    };
}

export function defaults (options) {
    return function decorate (target) {
        target.DEFAULTS = options;
    };
}



// WEBPACK FOOTER //
// ./project/client/src/core/lib/plugin.js